import { Medal, User, Users, Table2 } from "lucide-react";
import { IMAGES } from "../data/content";
import { PageHero } from "../components/shared/PageHero";
import { Reveal } from "../components/shared/Reveal";

const FOUNDATIONS = [
  { icon: Medal, title: "Results by Martial Art", text: "Official results for every discipline, published under each participating organisation's authority." },
  { icon: User, title: "Athlete Results", text: "Individual athlete results and competition records from Kumite Games events." },
  { icon: Users, title: "Club / Team Results", text: "Club and team standings recognising the communities behind the athletes." },
  { icon: Table2, title: "Medal Table", text: "The official Kumite Games medal table across all disciplines." },
];

export default function Results() {
  return (
    <>
      <PageHero
        eyebrow="Results"
        title="Honour the Victors"
        intro="The official home of Kumite Games results — by martial art, by athlete, by club, and the event medal table."
        image={IMAGES.muaythai}
        testId="results-page-hero"
      />
      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
        <div className="grid gap-5 sm:grid-cols-2">
          {FOUNDATIONS.map((f, i) => (
            <Reveal
              key={f.title}
              delay={i * 0.08}
              className="spotlight-card clip-notch border border-white/5 bg-ink-soft p-8"
            >
              <f.icon className="h-6 w-6 text-gold" />
              <h2 className="mt-5 font-head text-lg font-bold uppercase tracking-wide text-bone">{f.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{f.text}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15} className="mt-12 clip-notch border border-kred/25 bg-kred/[0.05] p-10 text-center sm:p-14">
          <p data-testid="results-notice" className="font-display text-3xl uppercase tracking-wide text-bone sm:text-4xl">
            Results will be published following <span className="text-kred">Kumite Games</span> events.
          </p>
          <p className="mx-auto mt-5 max-w-lg text-sm leading-relaxed text-slate-400">
            No results exist yet — the first chapter of Kumite Games history is still to be
            written. Official results will appear here after each event.
          </p>
        </Reveal>
      </section>
    </>
  );
}
